import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";
import credential from "../../API/Credentials.json";

export const deleteUserAccount = createAsyncThunk(
  "generalInfo/deleteUserAccount",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.DeleteAccount_API?.end_point;
      const apiMethod = credential?.request?.delete;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserAccount = createAsyncThunk(
  "generalInfo/updateUserAccount",
  async (apiData, { rejectWithValue }) => {
    try {
      const endpoint = credential?.UserUpdate_API?.end_point;
      const apiMethod = credential?.request?.post;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      }
      return rejectWithValue(response.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const GeneralInfoSlice = createSlice({
  name: "generalInfo",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteUserAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteUserAccount.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(deleteUserAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(updateUserAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateUserAccount.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(updateUserAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});
export default GeneralInfoSlice.reducer;
